/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：303
 */

"use strict"

module.exports = require(/* 1809 */"./1809/index")
